module.exports = __webpack_public_path__ + "static/img/图文3.0dda839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图文3.jpg
// module id = cyCC
// module chunks = 1